import React, { Fragment } from 'react'
import PropTypes from 'prop-types'
// import ReactTable from 'react-table'
// import 'react-table/react-table.css'
import './Table.scss'
class DatePicker extends React.Component {
  static propTypes = {
    error: PropTypes.any,
    onDateChange: PropTypes.func,
    helpText: PropTypes.string,
    date: PropTypes.any,
  }

  constructor(props) {
    super(props)
    this.state = {}
  }
  render() {
    return (
      <Fragment>
        <div>table</div>
        {/* <ReactTable {...props} /> */}
      </Fragment>
    )
  }
}

export default DatePicker



// WEBPACK FOOTER //
// ./src/components/Table/Table.js